import { render, staticRenderFns } from "./CloudOrgSupplier.vue?vue&type=template&id=5b6172ee&"
import script from "./CloudOrgSupplier.vue?vue&type=script&lang=js&"
export * from "./CloudOrgSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports